import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAssetViewerState } from '@hooks/useAssetViewerState';
import { UXP_SYNC_PREMIERE_PLAYHEAD } from '@helpers/uxpEmbeddedMediaViewer';
import { getPlayheadSyncSeconds } from '@pages/MediaViewer/helpers/getPlayheadSyncSeconds';

export function UxpPremierePlayheadSync() {
  const { assetId } = useParams();
  const { selectedCommentId, commentsList, playerTime } = useAssetViewerState();

  useEffect(() => {
    const { uxpHost } = window as unknown as {
      uxpHost?: { postMessage: (msg: object) => void };
    };
    if (!uxpHost || !assetId) return;

    const seconds = getPlayheadSyncSeconds(
      playerTime,
      selectedCommentId,
      commentsList
    );
    if (seconds == null) return;

    uxpHost.postMessage({
      type: UXP_SYNC_PREMIERE_PLAYHEAD,
      assetId,
      seconds
    });
  }, [assetId, selectedCommentId, commentsList, playerTime]);

  return null;
}
